import { Flex, Portal } from "@chakra-ui/react";
import { PledgeDashboard } from "@root/components/pledge-dashboard";
import { usePledgeDashboardTourGuide } from "@root/hooks/usePledgeDashboardTourGuide";
import { TourGuide, RestartTourButton } from "@root/components/tour-guide";

export const PledgeDashboardPage = () => {
  const { pledgeDashboardTourGuide, isMobile: isMobileTour } =
    usePledgeDashboardTourGuide();

  return (
    <Flex minW={"100%"} position={"relative"} className="projectsDashboard">
      <PledgeDashboard />

      {!isMobileTour && !pledgeDashboardTourGuide.isActive && (
        <Portal>
          <RestartTourButton
            onClick={pledgeDashboardTourGuide.startTour}
            position={{ bottom: "24px", right: "24px" }}
          />
        </Portal>
      )}

      {!isMobileTour &&
        pledgeDashboardTourGuide.isActive &&
        pledgeDashboardTourGuide.currentStepData && (
          <TourGuide
            isActive={pledgeDashboardTourGuide.isActive}
            currentStep={pledgeDashboardTourGuide.currentStepData}
            currentStepIndex={pledgeDashboardTourGuide.currentStep}
            totalSteps={pledgeDashboardTourGuide.totalSteps}
            onNext={pledgeDashboardTourGuide.nextStep}
            onBack={pledgeDashboardTourGuide.previousStep}
            onClose={pledgeDashboardTourGuide.stopTour}
            targetSelector={
              pledgeDashboardTourGuide.currentStepData.targetSelector
            }
            borderRadius="8px"
          />
        )}
    </Flex>
  );
};
